document.addEventListener('DOMContentLoaded', () => {
   if (document.querySelector('#wcl-accound-details-popup')) {
      const form = document.getElementById('wcl-accound-details-popup');

      // Get UI elements
      const selects = form.querySelectorAll('.wcl-modal-form__select[required]');
      const nextButtons = form.querySelectorAll('.wcl-js-step-next');
      const prevButtons = form.querySelectorAll('.wcl-modal-top__back');
      const messageBlock = form.querySelector('.wcl-message-alert');
      const message = messageBlock.querySelector('.wcl-message');
      const steps = form.querySelectorAll('.wcl-modal-form__step');

      let currentStep = 1;

      //Event handler for the "Continue" button to switch to the next step from the current step
      nextButtons.forEach(button => {
         button.addEventListener('click', function (event) {
            let isValid = true;

            selects.forEach(select => {
               // Check if the select is in the current step
               if (select.closest(`.wcl-modal-form__step[data-step="${currentStep}"]`)) {
                  // Check if a value is selected
                  if (!select.value) {
                     isValid = false;
                  }
               }
            });

            if (!isValid) {
               event.preventDefault();
               messageBlock.classList.add('show', 'error');
               message.textContent = multilanguage_object['All fields must be completed.'];
            } else {
               messageBlock.classList.remove('show', 'error');
               message.textContent = '';

               // Proceed to the next step
               nextStep(currentStep + 1);
            }
         });
      });

      //Event handler for the "Back" button to switch to the prev step from the current step
      prevButtons.forEach(button => {
         button.addEventListener('click', function () {
            if (currentStep > 1) {
               nextStep(currentStep - 1);
            }
         });
      });

      // Function for switching to the next step
      function nextStep(step) {
         const nextStepElement = form.querySelector(`.wcl-modal-form__step[data-step="${step}"]`);

         steps.forEach(stepElement => {
            stepElement.classList.remove('active');
         });

         if (nextStepElement) {
            nextStepElement.classList.add('active');
            currentStep = step;
         }
      }

      // Initialize the first step visibility
      nextStep(currentStep);
   }
});
